import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  forwardRef,
  Output,
  EventEmitter,
  ViewChild,
  ViewChildren,
  QueryList,
  AfterViewInit
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Observable, of, Subject, combineLatest} from 'rxjs';
import { takeUntil, map, take, skipWhile } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { AccordionPanelComponent, AccordionModule } from 'ngx-bootstrap/accordion';
import { SavedSearchSummaryDropdownComponent } from '../saved-search-summary-dropdown/saved-search-summary-dropdown.component';
import { chain, get } from 'lodash';
import MicroModal from 'micromodal';
import {
  commonRegex,
  ComponentConfig,
  Configuration,
  ConfigurationState,
  NotificationService,
  Notification,
  NotificationRecipient,
  UserService, LaunchDarklyService,
  emailFormatValidator,
  noSpecialCharsEmailValidator,
  invalidFormat,
  containsSpecialChars
} from 'remarketing-angular-library';
import { tenantClass } from '../../util/state-selectors';
import { AnalyticsService, SaComponent } from 'smartauction-frontend-micro-library';
import { CheckUnsavedForms } from '../../interfaces/check-unsaved-forms';
import { NotificationsService } from '../../services/notifications/notifications.service';
import { RemoveMobilePhoneModalComponent } from '../remove-mobile-phone-modal/remove-mobile-phone-modal.component';
import { RevokeTextMessageConsentComponent } from '../revoke-text-message-consent-modal/revoke-text-message-consent-modal.component';
import { MobilePhonePipe } from '../../pipes/mobile-phone/mobile-phone.pipe';
import { SmsModalComponent } from '../../../shared/components/sms-modal/sms-modal.component';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SaveChangesModalComponent } from '../save-changes-modal/save-changes-modal.component';
import { NgxMaskModule } from 'ngx-mask';
import { EditMobileMessageComponent } from '../edit-mobile-message/edit-mobile-message.component';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { EmailInputComponent, EmailInputConfig } from 'remarketing-ui-components-lib';
import { AlertTrackingConfig, AlertTrackingService } from '../../services/alert-tracking/alert-tracking.service';

const SEND_TYPE_TEXT = 'Text';
const SAVED_SEARCH_SUMMARY_TYPE = 'SSN';

const enum Mode {
  BUY = 'buy',
  EMAIL = 'email',
  MOBILE_PHONE = 'mobilePhone',
  SELL = 'sell'
}

const enum Category {
  BUY = 'Buy',
  SELL = 'Sell'
}

@Component({
    selector: 'app-user-contact',
    templateUrl: './user-contact.component.html',
    styleUrls: ['./user-contact.component.scss'],
    providers: [
        MobilePhonePipe,
        {
            provide: CheckUnsavedForms,
            useExisting: forwardRef(() => UserContactComponent)
        }
    ],
    imports: [TranslocoDirective, NgClass, ErrorMessageComponent, NgTemplateOutlet, SuccessMessageComponent, AccordionModule, EditMobileMessageComponent, FormsModule, ReactiveFormsModule, NgxMaskModule, RouterLink, SaveChangesModalComponent, RemoveMobilePhoneModalComponent, RevokeTextMessageConsentComponent, SmsModalComponent, AsyncPipe, MobilePhonePipe, EmailInputComponent, SavedSearchSummaryDropdownComponent]
})
export class UserContactComponent extends SaComponent implements OnInit, CheckUnsavedForms, AfterViewInit {
  @Select(ConfigurationState.configuration) private configuration$: Observable<Configuration>;
  @Select(ConfigurationState.coreComponentConfig('profile-settings')) profileConfig$: Observable<ComponentConfig>;
  @Select(tenantClass) tenantClass$: Observable<string>;
  @Output() closeParentAccordion = new EventEmitter();

  activeChildRoute: string;
  readonly activeClass = 'profile-nav__link--active';

  private cancelEditing$: Subject<boolean> = new Subject<boolean>();

  acknowledged = false;
  private sessionStorageKey = 'ibubble_alertsMoved';
  tenantName$: Observable<string>;
  tenantUuid$: Observable<string>;
  closeAlertIbubble = false;
  tenantName: string;
  tenantUuid: string;
  buyerShortCode$: Observable<string>;
  buyerShortCode: string;
  sellerShortCode$: Observable<string>;
  sellerShortCode: string;
  privacyURL$: Observable<string>;
  privacyURL: string;
  buyAlerts$: Observable<Array<Notification>>;
  sellAlerts$: Observable<Array<Notification>>;
  editMode: string;
  mobileNotifTenantText: string;
  factorPhone: string;
  factorEnrolled: boolean;
  contactForm: UntypedFormGroup;
  message: string;
  userProfile;
  recipient: NotificationRecipient;
  componentUuid: string;
  routerState: any;
  toggleAccordions = false;
  editModeEmail = false;
  editModeMobilePhone = false;
  showError = false;
  showSuccess = false;
  showBuyError = false;
  showBuySuccess = false;
  showSellError = false;
  showSellSuccess = false;
  buyIsOpen = false;
  sellIsOpen = false;
  hasSellerEligibility: boolean;
  myAlertsandNotifications: string;
  isMobile = window.innerWidth < 768;
  modalId = 'user-contact__save-changes-modal';
  optedNotifications: Array<Notification> = [];
  optedNotificationsOriginal: Array<Notification> = [];
  visibilityFlags: any = [];
  sellNotificationType: Array<string> = [];
  buyNotificationType: Array<string> = [];
  hasSavedSearches = true;
  selectedSavedSearchIds: Array<string> = [];
  userContactTranslations = {
    textEditYour: '',
    textAddYour: '',
    textMobileNumber: '',
    textOptIn: '',
    textEditEmail: '',
    textEmailAddress: '',
    textEnterValidEmail: '',
    emailContainsInvalidChars: ''
  };

  emailInputConfig = {
    inputFormControlName: 'emailAddress',
    labelFor: 'email',
    inputId: 'email'
  } as EmailInputConfig

  @ViewChildren('controlPersonalInfo') controlPersonalInfo: QueryList<ElementRef>;
  @ViewChild('sellAccordion') sellAccordion: AccordionPanelComponent;
  @ViewChild('buyAccordion') buyAccordion: AccordionPanelComponent;
  @ViewChild('accordionWrapper') accordionWrapper: ElementRef;
  @ViewChild('pageHeading') pageHeading: ElementRef;
  @ViewChild(RemoveMobilePhoneModalComponent) removeMobilePhoneModalComponent: RemoveMobilePhoneModalComponent;
  @ViewChild(RevokeTextMessageConsentComponent) revokeTextMessageConsentComponent: RevokeTextMessageConsentComponent;
  @ViewChild(SmsModalComponent) smsModal: SmsModalComponent;

  get isDrawerOpen(): boolean {
    return this.editModeEmail || this.editModeMobilePhone;
  }

  get isContactFormPristine(): boolean {
    return chain(this.contactForm.controls).every('pristine').value();
  }

  get isPhoneFormValid(): boolean {
    const { mobileConsent, phoneNumber } = this.contactForm.controls;
    const hasPhoneNumber = !!phoneNumber.value;
    const isConsentValid = !mobileConsent.value || (mobileConsent.value && hasPhoneNumber);
    return phoneNumber.valid && isConsentValid;
  }

  get phoneNumber(): string {
    return this.recipient && this.recipient.mobilePhone
      ? this.recipient.mobilePhone
      : this.userProfilePhoneNumber;
  }

  get userProfilePhoneNumber(): string {
    return this.userProfile && this.userProfile.mobilePhone ? this.userProfile.mobilePhone : '';
  }

  get emailAddress(): string {
    return this.recipient && this.recipient.email
      ? this.recipient.email
      : this.userProfileEmailAddress;
  }

  get userProfileEmailAddress(): string {
    return this.userProfile && this.userProfile.email ? this.userProfile.email : '';
  }

  get mobileConsent(): boolean {
    return this.recipient && this.recipient.mobileConsent ? this.recipient.mobileConsent : false;
  }

  get featureMobileNotif(): boolean {
    return this.launchDarklyService.getFeatureFlag('login-mobileNotificationTextEnabled', false);
  }

  get allyPrivacyLinkEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('profile-allyPrivacyLinkEnabled', false);
  }

  get requireMobileConsent(): boolean {
    return this.featureMobileNotif && !this.mobileConsent;
  }

  get isManageAlertsEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('profile-manageAlertsEnabled', false);
  }

  get inServiceVehiclesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }

  get addOrEditText() {
    return this.phoneNumber ? this.userContactTranslations.textEditYour : this.userContactTranslations.textAddYour;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private analyticsService: AnalyticsService,
    private notificationService: NotificationService,
    private notificationsService: NotificationsService,
    private alertTrackingService: AlertTrackingService,
    private store: Store,
    private readonly router: Router,
    private readonly mobilePhonePipe: MobilePhonePipe,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userService: UserService,
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly translocoService: TranslocoService
  ) {
    super();
    const currentNaviation = this.router.currentNavigation();

    if (currentNaviation && currentNaviation.extras && currentNaviation.extras.state) {
      this.routerState = currentNaviation.extras.state;
    }

    this.activatedRoute.queryParams.pipe(takeUntil(this.destroyed$)).subscribe((params: any) => {
      this.editModeMobilePhone = params.editModeMobilePhone === 'true';
      this.toggleAccordions = params.toggleAccordions === 'true';
    });
  }

  ngOnInit() {
    this.getTranslations();
    this.notificationsService.visibilityFlags$.pipe(takeUntil(this.destroyed$)).subscribe(flags => {
      this.visibilityFlags = flags;
    });
    this.buyAlerts$ = this.notificationsService.buyAlerts$.asObservable();
    this.sellAlerts$ = this.notificationsService.sellAlerts$.asObservable();

    this.store
      .select(state => state.user.userProfile)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(profile => {
        this.userProfile = profile;
      });

    this.tenantName$ = this.configuration$.pipe(map((configuration: Configuration) => configuration.tenantName));
    this.tenantName$.pipe(takeUntil(this.destroyed$)).subscribe(tenantName => (this.tenantName = tenantName));

    this.tenantUuid$ = this.configuration$.pipe(map((configuration: Configuration) => configuration.tenantUuid));
    this.tenantUuid$.pipe(takeUntil(this.destroyed$)).subscribe(tenantUuid => (this.tenantUuid = tenantUuid));

    this.buyerShortCode$ = this.profileConfig$.pipe(map(profileConfig => get(profileConfig, 'labels.buyer-short-code', undefined)));
    this.buyerShortCode$.pipe(takeUntil(this.destroyed$)).subscribe(buyerShortCode => (this.buyerShortCode = buyerShortCode));
    this.sellerShortCode$ = this.profileConfig$.pipe(map(profileConfig => get(profileConfig, 'labels.seller-short-code', undefined)));
    this.sellerShortCode$.pipe(takeUntil(this.destroyed$)).subscribe(sellerShortCode => (this.sellerShortCode = sellerShortCode));

    this.privacyURL$ = this.profileConfig$.pipe(map(profileConfig => get(profileConfig, 'labels.privacy-policy-url', undefined)));
    this.privacyURL$.pipe(takeUntil(this.destroyed$)).subscribe(privacyURL => (this.privacyURL = privacyURL));
    this.contactForm = this.formBuilder.group({
      emailAddress: [this.userProfile.email, [Validators.required, emailFormatValidator(), noSpecialCharsEmailValidator()]],
      phoneNumber: [this.mobilePhonePipe.transform(this.userProfile.mobilePhone), [Validators.minLength(10), Validators.maxLength(12), Validators.pattern(commonRegex.noLeadingZeroOrOneMobileNumberValidator.source.toString())]],
      mobileConsent: [false, [Validators.required]],
    });

    this.contactForm.controls.phoneNumber.valueChanges
      .pipe(takeUntil(this.destroyed$)).subscribe(() => this.handleMobilePhoneChange());

    this.setTermsAndConditionsLink();

    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(configuration => {
        this.mobileNotifTenantText = get(configuration, 'tenantFullName', null);
      });

    this.store
      .select(state => state.org.organization)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(organization => {
        this.hasSellerEligibility = organization?.organizationProfile.eligibleToSell;
      });

    this.getRecipient(recipient => {
      if (this.buyAccordion) {
        this.buyAccordion.isDisabled = false;
      }
      if (this.sellAccordion) {
        this.sellAccordion.isDisabled = false;
      }

      this.contactForm.controls.emailAddress.setValue(recipient.email);
      this.contactForm.controls.phoneNumber.setValue(this.mobilePhonePipe.transform(recipient.mobilePhone));
      this.contactForm.controls.mobileConsent.setValue(!!recipient.mobileConsent);

      if (this.toggleAccordions) {
        this.toggleBuyAccordion();
        this.toggleSellAccordion();
        this.scrollIntoViewAlertsHeader();
      }
    });
    this.acknowledged = sessionStorage.getItem(this.sessionStorageKey) === 'true';

    this.analyticsService.waitForDigitalData()
      .pipe(
        skipWhile(ready => !ready),
        take(1)
      ).subscribe(() => {
        this.analyticsService.trackPageLoad({
          page: {
            pageName: `${this.analyticsService.digitalData?.page?.category?.site}:Profile Settings:My Information:Contact`,
            section: 'Profile Settings',
            subsection: 'My Information',
            title: 'Contact'
          }
        });
      });
  }

  get invalidFormatEmail(): boolean {
    return invalidFormat(this.contactForm, 'emailAddress');
  }

  get emailContainsSpecialChars(): boolean {
    return containsSpecialChars(this.contactForm, 'emailAddress');
  }

  get showSellerAlerts() {
    return this.userService.isSellerRole() && this.hasSellerEligibility;
  }

  get isSmsTermsLinkEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('smsTermsEnabled', false);
  }

  ngAfterViewInit(): void {
    if (this.routerState && this.routerState.focus) {
      this.pageHeading.nativeElement.focus();
    }
    this.setAccordionRoles();
  }

  isSavedSearchSummaryAlert(alert): boolean {
    return alert?.type === SAVED_SEARCH_SUMMARY_TYPE;
  }

  setTermsAndConditionsLink() {
    const stateValue = this.store.selectSnapshot(ConfigurationState.configuration).smsTermsUrl;
    return this.isSmsTermsLinkEnabled ? '/ui/smsterms' : stateValue;
  }

  setAccordionRoles() {
    const accordion = this.accordionWrapper.nativeElement.querySelector('.alert-settings');
    const navItems = this.accordionWrapper.nativeElement.querySelectorAll('.child-accordion .panel');

    accordion.removeAttribute('role');

    navItems.forEach(item => {
      item.setAttribute('role', 'list');
      item.children[0].setAttribute('role', 'listitem');
      item.children[1].setAttribute('role', 'listitem');
    });
  }

  checked(type: string): boolean {
    const notification: Notification = this.optedNotifications.find(n => n.type === type);

    if (this.featureMobileNotif && notification && SEND_TYPE_TEXT === notification.sendType) {
      return this.mobileConsent;
    }

    return !!notification;
  }

  private trackAlerts(isSuccess: boolean, accordion): void {
    combineLatest([
      this.buyAlerts$.pipe(take(1)),
      this.sellAlerts$.pipe(take(1))
    ])
      .subscribe(([buyAlerts,sellAlerts]) => {
        const config = this.alertTrackingService.createConfigForAccordion(
          accordion,
          buyAlerts,
          sellAlerts,
          (alert) => this.checkVisibility(alert),
          (alert) => this.getAlertDescription(alert),
          (type) => this.checked(type)
        );
        this.alertTrackingService.trackAlertPreferences(config,isSuccess);
      });
  }

  getAlertDescription(alert: Notification): string {
    return this.translocoService.translateObject('notifications.' + alert.type);
  }

  toggleBuyAccordion() {
    if (!this.buyAccordion.isDisabled) {
      setTimeout(() => {
        this.buyIsOpen = !this.buyIsOpen;
      }, 100);
    }
    if (this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal, Category.BUY)) {
      this.showNavigationAlert();
    }
  }

  toggleSellAccordion() {
    if (!this.sellAccordion.isDisabled) {
      setTimeout(() => {
        this.sellIsOpen = !this.sellIsOpen;
      }, 100);
    }
    if (this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal, Category.SELL)) {
      this.showNavigationAlert();
    }
  }

  openMicroModal(modalId: string) {
    MicroModal.show(modalId, {
      disableScroll: true
    });
    const heading = document.querySelector(`#${modalId} h1`) as HTMLElement;
    if (heading) {
      heading.focus();
    }
  }

  handleMobilePhoneChange() {
    this.contactForm.controls.mobileConsent.setValue(false);
  }

  onEditEmail() {
    this.showSuccess = false;
    this.editModeMobilePhone = false;
    this.editModeEmail = true;
    this.editMode = Mode.EMAIL;
  }

  onEditMobilePhone() {
    this.showSuccess = false;
    this.editModeEmail = false;
    this.editModeMobilePhone = true;
    this.editMode = Mode.MOBILE_PHONE;
    this.markMobilePhoneFieldsPristine();
    this.afterEditPersonalInfo();
  }

  afterEditPersonalInfo() {
    setTimeout(() => {
      const input = this.controlPersonalInfo.first.nativeElement;
      if (input) {
        input.focus();
      }
    }, 0);
  }

  showBuyAndSellOptions() {
    this.scrollIntoViewAlertsHeader();
    this.sellIsOpen = true;
    this.buyIsOpen = true;
  }

  showNavigationAlert(): Observable<boolean> {
    this.openMicroModal(this.modalId);
    this.cancelEditing$ = new Subject<boolean>();
    return this.cancelEditing$.asObservable();
  }

  cancelEditing() {
    if (this.editMode === Mode.BUY) {
      this.resetNotifications(Category.BUY);
      this.focusAlertsHeader();
      this.buyIsOpen = false;
      this.buyAccordion.isOpen = false;
      this.buyAccordion.isDisabled = false;
    }
    else if (this.editMode === Mode.SELL) {
      this.resetNotifications(Category.SELL);
      this.focusAlertsHeader();
      this.sellIsOpen = false;
      this.sellAccordion.isOpen = false;
      this.sellAccordion.isDisabled = false;
    }
    else if (this.editMode === Mode.MOBILE_PHONE) {
      this.contactForm.controls.phoneNumber.setValue(this.mobilePhonePipe.transform(this.recipient.mobilePhone));
      this.contactForm.controls.phoneNumber.markAsPristine();
      this.editModeMobilePhone = false;
    }
    else if (this.editMode === Mode.EMAIL) {
      this.contactForm.controls.emailAddress.setValue(this.recipient.email);
      this.contactForm.controls.emailAddress.markAsPristine();
      this.editModeEmail = false;
    }
    else {
      this.focusAlertsHeader();
      this.resetNotifications(Category.SELL);
      this.resetNotifications(Category.BUY);
      this.buyIsOpen = false;
      this.sellIsOpen = false;
      this.buyAccordion.isOpen = false;
      this.buyAccordion.isDisabled = false;
      this.sellAccordion.isOpen = false;
      this.sellAccordion.isDisabled = false;
    }

    this.cancelEditing$.next(true);
    this.cancelEditing$.complete();
    this.closeParentAccordion.emit();
  }

  resetNotifications(category) {
    this.optedNotifications = this.optedNotificationsOriginal.filter(n => {
      if (n.category === category) {
        return this.optedNotificationsOriginal.find(ogN => ogN.type === n.type);
      } else {
        return true;
      }
    });
  }

  continueEditing() {
    this.cancelEditing$.next(false);
    this.cancelEditing$.complete();
  }

  cancelBuy() {
    this.editMode = Mode.BUY;
    if (this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal, Category.BUY)) {
      this.showNavigationAlert();
    } else {
      this.focusAlertsHeader();
      this.buyIsOpen = false;
      this.buyAccordion.isOpen = false;
      this.buyAccordion.isDisabled = false;
    }
  }

  cancelSell() {
    this.editMode = Mode.SELL;
    if (this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal, Category.SELL)) {
      this.showNavigationAlert();
    } else {
      this.focusAlertsHeader();
      this.sellIsOpen = false;
      this.sellAccordion.isOpen = false;
      this.sellAccordion.isDisabled = false;
    }
  }

  cancelCurrentDrawer() {
    if (this.editModeEmail) {
      this.cancelEmail();
    }
    if (this.editModeMobilePhone) {
      this.cancelMobilePhone();
    }
  }

  cancelMobilePhone() {
    this.editMode = Mode.MOBILE_PHONE;
    if (this.isContactFormPristine) {
      this.editModeMobilePhone = false;
    } else {
      this.showNavigationAlert();
    }
  }

  cancelEmail() {
    this.editMode = Mode.EMAIL;
    if (this.isContactFormPristine) {
      this.editModeEmail = false;
    } else {
      this.showNavigationAlert();
    }
  }

  saveMobilePhone() {
    if (this.contactForm.valid && this.isPhoneFormValid){
      if ((this.contactForm.value.mobileConsent === false && this.recipient.mobileConsent === true)) {
        this.revokeTextMessageConsentComponent.show();
      }
      if (this.isSmsOtpEnabled()) {
        this.handleSmsFactorEnrollment();
      } else {
        this.saveMobilePhoneConfirmed();
      }
    }
  }

  handleSmsFactorEnrollment() {
    const smsFactor$ = this.userService.getSmsFactor(this.tenantUuid, this.getUserId());
    smsFactor$.pipe(takeUntil(this.destroyed$)).subscribe(smsFactor => {
      if (smsFactor.enrolled) {
        if (!this.recipient.mobilePhone) {
          this.saveMobilePhoneConfirmed();
        } else {
          if (this.getMobilePhone() !== smsFactor.mobilePhone) {
            this.deleteSmsFactor();
            this.sendOTP();
          } else {
            this.addMobilePhoneConsent();
          }
        }
      }
      else {
        if (this.getMobilePhone() === '') {
          this.saveMobilePhoneConfirmed();
        } else {
          this.sendOTP();
        }
      }
    });
  }

  deleteSmsFactor() {
    this.userService.deleteSmsFactor(this.getUserId()).pipe(take(1)).subscribe(() => console.log('SmsFactor deleted'));
  }

  saveMobilePhoneRevokeConfirmed() {
    this.saveMobilePhoneConfirmed(true);
  }

  saveMobilePhoneConfirmed(revoked = false) {
    this.showSuccess = false;
    this.showError = false;
    let notifs = this.optedNotificationsOriginal;

    if (revoked) {
      notifs = notifs.filter(notif => notif.sendType !== SEND_TYPE_TEXT);
    }

    const payload = {
      ...this.recipient,
      optedNotifications: notifs,
      mobilePhone: this.getMobilePhone(),
      mobileConsent: this.contactForm.value.mobileConsent
    };

    this.updateRecipient(payload, recipient => {
      this.editModeMobilePhone = false;
      this.setMessage();
      this.showSuccess = true;
      this.updateStateUser(recipient.mobilePhone, recipient.email);

      if (revoked) {
        this.optedNotifications = this.optedNotifications.filter(notif => notif.sendType !== SEND_TYPE_TEXT);
        this.optedNotificationsOriginal = JSON.parse(JSON.stringify(recipient.optedNotifications));
      }
    },
      () => {
        this.showError = true;
      });
  }

  areNotEqual(array, ogArray, category?) {
    let arr1;
    let arr2;
    if (category) {
      arr1 = array
        .concat()
        .filter(n => n.category === category)
        .sort();
      arr2 = ogArray
        .concat()
        .filter(n => n.category === category)
        .sort();
    } else {
      arr1 = array.concat().sort();
      arr2 = ogArray.concat().sort();
    }

    if (arr1.length !== arr2.length) {
      return true;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].type !== arr2[i].type) {
        return true;
      }
    }

    return false;
  }

  hasUnsavedForms(): boolean {
    if (this.isDrawerOpen) {
      return !this.isContactFormPristine;
    }
    else {
      return this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    if (this.hasUnsavedForms()) {
      event.returnValue = true;
    }
  }

  showAlert() {
    this.openMicroModal(this.modalId);
  }

  updateNotificationBuy(e, notification) {
    this.editMode = Mode.BUY;
    this.updateNotification(e, notification);
    this.buyAccordion.isDisabled = this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal, Category.BUY);
  }

  updateNotificationSell(e, notification) {
    this.editMode = Mode.SELL;
    this.updateNotification(e, notification);
    this.sellAccordion.isDisabled = this.areNotEqual(
      this.optedNotifications,
      this.optedNotificationsOriginal,
      Category.SELL
    );
  }

  updateNotification(e, notification) {
    if (e.target.checked) {
      this.optedNotifications.push(notification);
    } else {
      const i = this.optedNotifications.findIndex(n => n.type === notification.type);
      this.optedNotifications.splice(i, 1);
    }
  }

  checkVisibility(alert) {
    for (const key in this.visibilityFlags) {
      if (alert && alert.description && key.toLowerCase() === alert.description.toLowerCase()) {
        return this.visibilityFlags[key].visible;
      }
    }
  }

  hasAlertType(alerts: any[], alertType: string): boolean {
    let hasAlerts = false;
    alerts.forEach(alert => {
      if (alert.sendType === alertType && this.checkVisibility(alert)) {
        hasAlerts = true;
      }
    });
    return hasAlerts;
  }

  focusAlertsHeader() {
    setTimeout(() => {
      const header = document.getElementById('alerts-header') as HTMLElement;
      if (header) {
        header.focus();
      }
    }, 0);
  }

  scrollIntoViewAlertsHeader() {
    setTimeout(() => {
      const header = document.getElementById('alerts-header');
      if (header) {
        header.scrollIntoView();
      }
    }, 200);
  }

  focusMessage(id) {
    setTimeout(() => {
      const message = document.getElementById(id) as HTMLElement;
      if (message) {
        message.focus();
      }
    }, 100);
  }

  isOpenChange(e, type) {
    if (e) {
      setTimeout(() => {
        const table = document.getElementById(type + '_table') as HTMLElement;
        if (table) {
          table.focus();
        }
      }, 200);
    }
  }

  onSuccessGoTo() {
    this.sellIsOpen = true;
    this.buyIsOpen = true;
  }

  onRemoveMobilePhoneClicked() {
    this.removeMobilePhoneModalComponent.show();
  }

  setMessage() {
    this.translocoService.selectTranslateObject('profileManagement.userContact').pipe(take(1)).subscribe(translate => {
      this.myAlertsandNotifications = ' ' + (this.isManageAlertsEnabled ? translate.textSaveChanges : translate.textSaveChangesNoLink);
      this.message = this.myAlertsandNotifications;
    });
  }

  showBuyandSell() {
    this.buyIsOpen = true;
    this.sellIsOpen = true;
  }

  updateStateUser(phoneNumber: string, emailAddress: string) {
    const currentState = this.store.selectSnapshot(state => state);
    this.store.reset({
      ...currentState,
      user: {
        ...currentState.user,
        userProfile: {
          ...this.userProfile,
          mobilePhone: phoneNumber,
          email: emailAddress
        }
      }
    });
  }

  trackNotifications(accordion){
    this.analyticsService.track('customEvent', {
      name: 'MOA Tracking and Analytics',
      type: 'customEvent',
      category: 'UserInteraction:CustomEvent',
      attr: {
        'optedNotifications' : this.printNotifs(this.optedNotifications, accordion),
      },
    })
  }

  printNotifs(notifications: Array<any>, accordion) {
    const notifs : Array<String> = [];
    for(const notification of notifications) {
      if(notification.category == accordion) {
        const category = notification.category;
        const sendType = notification.sendType;
        const description = notification.description;
        const finalString = 'Category: ' + category + ', Alert Type: ' + sendType + ', Selected Alert: ' + description;
        notifs.push(finalString)
      }
    }
    return notifs
  }

  saveBuyNotifs() {
    this.showBuyError = false;
    this.showBuySuccess = false;
    this.saveNotifs(() => {
      this.showBuySuccess = true;
      this.focusMessage('buy-success-message');
      this.buyAccordion.isDisabled = false;
    }, () => {
      this.showBuyError = true;
      this.focusMessage('buy-error-message');
    }, 'Buy');
  }

  saveSellNotifs() {
    this.showSellError = false;
    this.showSellSuccess = false;

    this.saveNotifs(
      () => {
        this.focusMessage('sell-success-message');
        this.sellAccordion.isDisabled = false;
        this.showSellSuccess = true;
      },
      () => {
        this.showSellError = true;
        this.focusMessage('sell-error-message');
      },
      'Sell'
    );
  }

  saveNotifs(callback, error, accordion) {
    const payload = {
      ...this.recipient,
      optedNotifications: this.optedNotifications,
      tenantUuid: this.tenantUuid,
      savedSearchIds: this.selectedSavedSearchIds
    };

    this.trackNotifications(accordion);

    this.updateRecipient(payload,
      recipient => {
        if (recipient.optedNotifications) {
          this.optedNotifications = recipient.optedNotifications;
          this.optedNotificationsOriginal = JSON.parse(JSON.stringify(recipient.optedNotifications));
        }
        this.trackAlerts(true,accordion);
        callback();
      },
      () => {
        this.trackAlerts(false,accordion);
        error();
      }
    );
  }

  saveEmail() {
    if (this.contactForm.valid) {
      this.showSuccess = false;
      this.showError = false;

      const payload = {
        ...this.recipient,
        optedNotifications: this.optedNotificationsOriginal,
        email: this.contactForm.value.emailAddress
      };

      this.updateRecipient(payload, recipient => {
        this.editModeEmail = false;
        this.setMessage();
        this.showSuccess = true;
        this.updateStateUser(recipient.mobilePhone, recipient.email);
      },
        () => {
          this.showError = true;
        });
    }
  }

  private getRecipient(callback?) {
    return this.notificationService
      .getRecipient(this.userProfile.userUuid)
      .pipe(take(1))
      .subscribe(recipient => {
        this.recipient = recipient;
        this.optedNotifications = recipient.optedNotifications;
        this.optedNotificationsOriginal = JSON.parse(JSON.stringify(recipient.optedNotifications));
        this.selectedSavedSearchIds = recipient.savedSearchIds || [];


        if (callback) {
          callback(recipient);
        }
      }
      );
  }

  private updateRecipient(payload, callback?, error?) {
    return this.notificationService
      .updateRecipient(this.userProfile.userUuid, payload)
      .pipe(take(1))
      .subscribe(recipient => {
        this.recipient = recipient;
        if (callback) {
          callback(recipient);
        }
      }, () => {
        if (error) {
          error();
        }
      }
      );
  }

  addMobilePhoneConsent() {
    this.showSuccess = false;
    this.showError = false;

    const payload = {
      ...this.recipient,
      mobileConsent: true,
    };

    this.updateRecipient(payload, recipient => {
      this.setMessage();
      this.showSuccess = true;
      this.markMobilePhoneFieldsPristine();
      this.editModeMobilePhone = false;
    }, () => {
      this.showError = true;
    });
  }

  removeMobilePhoneConfirmed() {
    this.showSuccess = false;
    this.showError = false;

    const payload = {
      ...this.recipient,
      mobilePhone: '',
      mobileConsent: false,
      optedNotifications: this.optedNotificationsOriginal.filter(notif => notif.sendType !== SEND_TYPE_TEXT)
    };

    this.updateRecipient(payload, recipient => {
      this.setMessage();
      this.showSuccess = true;
      this.handleMobilePhoneChange();
      this.updateStateUser(recipient.mobilePhone, recipient.email);
      this.contactForm.controls.phoneNumber.reset();
      this.markMobilePhoneFieldsPristine();
      this.optedNotifications = this.optedNotifications.filter(notif => notif.sendType !== SEND_TYPE_TEXT);
      this.optedNotificationsOriginal = JSON.parse(JSON.stringify(recipient.optedNotifications));
    }, () => {
      this.showError = true;
    });
  }

  markMobilePhoneFieldsPristine(): void {
    this.contactForm.controls.phoneNumber.markAsPristine();
    this.contactForm.controls.mobileConsent.markAsPristine();
  }

  sendOTP() {
    this.smsModal.show();
  }

  getMobilePhone() {
    const phoneNumber = get(this.contactForm, 'value.phoneNumber', '');

    if (phoneNumber) {
      return phoneNumber.replaceAll('-', '');
    }

    return '';
  }

  getUserId() {
    return get(this.userProfile, 'userId', '');
  }

  advanceAfterSmsModal(isSuccessfullyEnrolled: boolean) {
    if (isSuccessfullyEnrolled) {
      this.saveMobilePhoneConfirmed();
    }
  }

  isSmsOtpEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('smsOtpEnabled', false);
  }

  isAlertsPageEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('profile-alertsPageEnabled', false);
  }

  getTranslations() {
    const keyParams = {
      'profileManagement.userContact': {}
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.setMessage();
      this.userContactTranslations.textAddYour = translate[0].textAddYour;
      this.userContactTranslations.textEditYour = translate[0].textEditYour;
      this.userContactTranslations.textMobileNumber = translate[0].textMobileNumber;
      this.userContactTranslations.textOptIn = translate[0].textOptIn;
      this.userContactTranslations.textEditEmail = translate[0].textEditEmail;
      this.userContactTranslations.textEmailAddress = translate[0].textEmailAddress;
      this.userContactTranslations.textEnterValidEmail = translate[0].textEnterValidEmail;
      this.userContactTranslations.emailContainsInvalidChars = translate[0].emailContainsInvalidChars;
    });
  }

  destroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  close() {
    this.acknowledged = true;
    sessionStorage.setItem(this.sessionStorageKey, 'true');
    this.destroy();
  }

  navigateTo(route) {
    setTimeout(() => this.router.navigateByUrl( route ), 0);
  }

  shouldDisplayAlertNotice() {
    return (this.isAlertsPageEnabled() && !this.acknowledged && !this.isMobile) && this.isManageAlertsEnabled;
  }
}
